<template src="./template.html"></template>
<script>
    import { mapGetters } from 'vuex';
    import axios from 'axios';
    import CostTable from '../../modules/01_costtable';
    import PageHeading from '../../modules/03_page_heading';
    import { Tooltip } from '../../../directives/tooltip';
    import {
        PANEL_AVAILABLE, PANEL_LOCKED, PANEL_TAKEN,
        REMOVE_SELECTED_PANEL,
        SET_SELECTED_PANEL,
        UPDATE_PANEL_PRICE,
        UPDATE_STEPS
    } from '../../../store/types';

    export default {
        data () {
            return {
                tooltipText: 'Dieses Modul gehört bereits: ',
                panelNotification: false,
                panelReservedNotification: false,
            };
        },
        directives: { Tooltip },
        components: { CostTable, PageHeading },
        computed: {
            ...mapGetters([
                'get_wording', 'get_panels', 'get_selected_panels_ids', 'get_supplier',
                'get_max_panels', 'get_selected_panels', 'get_order_created',
                'get_selection', 'get_building_info', 'get_selected_building_slug']),
            step2Text: function () {
                var textAPI = this.get_wording.step2_text;
                var firstPart = textAPI.slice(0, textAPI.search('Sektor') - 1) + ' ' + this.get_selection.fieldName;
                var secondPart = textAPI.slice(textAPI.search('entschieden') - 1, textAPI.search('aus') + 3) + ' ' + this.get_panels.length;
                var thirdPart = textAPI.slice(textAPI.search('aus') + 3, textAPI.length);
                return firstPart + ' ' + secondPart + ' ' + thirdPart;
            },
        },
        props: ['step'],
        beforeMount () {
            this.$store.dispatch(UPDATE_STEPS, this.$props.step);
        },
        created () {
            // Check route to redirect
            if (this.get_order_created) {
                this.$router.push('/');
            } else if (this.get_selection.activeField === 0) {
                this.$router.push(`/${this.$route.params.buildingAddress}`);
            } else {
                const activePanels = this.get_selection.activePanels;
                if (activePanels.length) {
                    this.setPanelLocked(activePanels.join());
                }
            }
        },
        methods: {
            nextStep () {
                this.$router.push(`/${this.$route.params.buildingAddress}/step-3`);
            },
            getPanelName (panel) {
                if (panel.status === PANEL_TAKEN) {
                    return panel.panel_name
                }

                if (panel.status === PANEL_AVAILABLE) {
                    if (this.get_selected_panels_ids.indexOf(panel.id) > -1) {
                        // PANEL SELECTED
                        return panel.panel_name || `${this.get_wording.panel_name} ${panel.panel_number}`;
                    } else {
                        // PANEL HOVER
                        return this.get_wording.choose;
                    }
                } else {
                    return panel.panel_name;
                }

                if (panel.status === PANEL_LOCKED) {
                    return this.get_wording.choose;
                }

                return '';
            },
            getMaxSelectedInfoText () {
                let infoText = this.get_wording.module_nr_exceed;
                return infoText.replace('Kontakt', '<a href="mailto:' + this.get_building_info.supplier.contact_mail + '">Kontakt</a>');
            },
            togglePanelSelection (panel, index) {
                const buildingId = this.get_selection.activeBuilding;
                const fieldId = this.get_selection.activeField;
                const panelApiRoute = `${this.$apiUrl}/building/${buildingId}/field/${fieldId}/panel/${panel.id}`;
                const panelToggled = !panel.selected;

                if (this.get_selected_panels_ids.length >= this.get_max_panels) {
                    this.panelNotification = true;
                } else {
                    axios.put(panelApiRoute, { panel_selected: panelToggled })
                        .then((resp) => {
                            if (panel.panel_cost != resp.data.data.panel_cost) {
                                this.$store.dispatch(UPDATE_PANEL_PRICE, resp.data.data);
                            }
                            // check status from response, not from panel in store
                            const panelServerStatus = resp.data.data.status;

                            switch (panelServerStatus) {
                                case PANEL_AVAILABLE:
                                    this.$store.dispatch(REMOVE_SELECTED_PANEL, panel.id);
                                    break;
                                case PANEL_LOCKED:
                                    this.$store.dispatch(SET_SELECTED_PANEL, {
                                        id: panel.id,
                                        name: `${this.get_wording.panel_name} ${panel.panel_number}`
                                    });
                                    break;
                            }
                        })
                        .catch(() => {
                            this.panelReservedNotification = true;
                        });
                }


                    
            },
            removeAndNotiify(id) {
                this.$store.dispatch(REMOVE_SELECTED_PANEL, id);
                this.setPanelAvailable(id);
                this.$store.dispatch('SET_NOTIFICATION', {
                    message: this.get_wording.module_nr_exceed,
                    type: 'warning'
                });
            },
            setPanelLocked(panelId) {
                const selection = this.get_selection;
                const buildingId = selection.activeBuilding;
                const fieldId = selection.activeField;

                const panelApiRoute = `${this.$apiUrl}/building/${buildingId}/field/${fieldId}/panel/locked`;
                axios.put(panelApiRoute, { panel_id: panelId });
            },
            getPanelTakenTooltip(panel) {
                let text = '';
                if (panel.status === PANEL_TAKEN) {
                    text = this.get_wording.panel_taken_tooltip_text;
                    if (panel.show_name_public) {
                        text = this.get_wording.panel_taken_tooltip_text_with_owner.replace('{{owner_name}}', panel.owner.name);
                    }
                }
                return text;
            },
        },
    };

</script>



// WEBPACK FOOTER //
// src/components/pages/02_panel/index.vue